import { apiClient } from "./apiclient";

export const saveOrUpdateDailyReport = (dto, token, userInfoId) =>
    apiClient.post("/api/daily-report/save-or-update-batch", dto, {
        headers: { Authorization: `Bearer ${token}` },
        params: { userInfoId },
    });

export const getDailyReportByUserAndDate = (
  token,
  userInfoId,
  fromDate,
  toDate
) =>
  apiClient.get("/api/daily-report/by-user-date-range", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      userInfoId,
      fromDate,
      ...(toDate && { toDate })
    },
  });
  
  export const getDailySummaryByUserAndDate = (token, userInfoId, date) =>
  apiClient.get("/api/daily-report/summary", {
    headers: { Authorization: `Bearer ${token}` },
    params: { userInfoId, date },
  });

export const getAllUsers = (token) =>
  apiClient.get("/allusers", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getStoriesByModule = (moduleId, token) =>
  apiClient.get(`/api/story-modules/stories-by-module/${moduleId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  